import { Plugin } from "grapesjs";
import loadComponents from "./components";
import loadBlocks from "./block";
import {
  PluginOptions,
  RequiredPluginOptions,
} from "../../../../../types/types";

const plugin: Plugin<PluginOptions> = (editor, opts = {}) => {
  const options: RequiredPluginOptions = {
    id: "blog-list",
    label: "Blog List",
    block: {},
    style: "",
    styleAdditional: "",
    classPrefix: "blog-list",
    ...opts,
  };

  loadBlocks(editor, options);
  loadComponents(editor, options);
};

export default plugin;
